import { YouTube } from "$components";
import MotionImage from "../../../../content/articles/2018-03-17-introduction-react-motion-tutorial/react-motion.gif";
import React from 'react';
export default {
  YouTube,
  MotionImage,
  React
};